<div class="claroImageButton-container" [style.background-color]="containerBkgrndColor" [ngClass]="{'highlighted': isHighlighted,'is-mobile-view': isMobileView}" (click)="containerClicked()">
    <div class="claroImageButton-innerContainer" [ngClass]="{'selected': isSelected, 'is-mobile-view': isMobileView}">
        <span class="claroImageButton-imageSection">
            <img class="claroImageButton-image" [ngClass]="{'is-mobile-view': isMobileView}" [src]="image">
        </span>
        <span class="claroImageButton-textSection">
            {{text}}
        </span>
    </div>
</div>
